import { render, staticRenderFns } from "./Block4Creation.vue?vue&type=template&id=33564bfd&scoped=true&"
import script from "./Block4Creation.vue?vue&type=script&lang=js&"
export * from "./Block4Creation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33564bfd",
  null
  
)

export default component.exports